import { useTranslation } from "react-i18next";
import NewtonDividedByMillimetreSquared from "../../../../../components/Math/Units/Metric/NewtonDividedByMillimetreSquared";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function CharakteristischeSpannungsschwingbreite({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.characteristicStressRange")}</p>}
      indicesValue={
        <span>
          &Delta;&sigma;<sub>R,k</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={value} decimalScale={0} />
        </span>
      }
      unitValue={<NewtonDividedByMillimetreSquared />}
    />
  );
}

export default CharakteristischeSpannungsschwingbreite;
